function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../../locales/keys';
import { DateRangeShortcutHelper, i18n, PermissionService, SessionSelectors } from 'invision-core';
import { RouteParams } from '../../../reducers/selectors/customer.selectors';
import { CurrentRedemptionCodeTableDataSelector, IsFetchingRedemptionCodeRedemptionsSelector, RedemptionCodeRedemptionsCurrentPageNumberSelector, RedemptionCodeRedemptionsRecordCountSelector, RedemptionCodeRedemptionsRedemptionDateEndFilterSelector, RedemptionCodeRedemptionsRedemptionDateStartFilterSelector, RedemptionCodeRedemptionsSelectedPageSizeSelector, RedemptionCodeRedemptionsTotalPageNumberSelector } from '../../../reducers/selectors/coupon.redemption.code.selectors';
import { searchCouponDetailsCouponRedemptions, setRedemptionCodeRedemptionsCurrentPage, setRedemptionCodeRedemptionsDateEndFilter, setRedemptionCodeRedemptionsDateStartFilter, setRedemptionCodeRedemptionsPageSizePreference } from '../../../reducers/actions/coupon.redemption.code.actions';
import { CustomerCouponsErrorSelector } from '../../../reducers/selectors/customer.coupons.selectors';
import { COUPON_REDEMPTION_CODE_VIEW_ACCESS } from '../../../security.attributes';
import { LanguageHeaderSelector } from 'invision-core/src/components/session/session.selectors';
var RedemptionCodeDetailsRedemptionsController = /*#__PURE__*/function () {
  function RedemptionCodeDetailsRedemptionsController($ngRedux, $timeout) {
    _classCallCheck(this, RedemptionCodeDetailsRedemptionsController);
    this.localeKeys = LocaleKeys;
    this.$ngRedux = $ngRedux;
    this.$timeout = $timeout;
  }
  return _createClass(RedemptionCodeDetailsRedemptionsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.columnDefs = [{
        field: 'RedemptionDate',
        displayName: i18n.translate(LocaleKeys.COUPONS.REDEMPTION_DATE),
        cellFilter: 'date:"shortDate"',
        width: 165
      }];
      this.resendRedemptionCodePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.resendRedemptionCodePopupApi = api;
        }
      };
      this.resendRedemptionCodeErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.resendRedemptionCodeErrorPopupApi = event.api;
        }
      };
      this.mapStateToTarget = function (store) {
        return {
          currentPageNumber: RedemptionCodeRedemptionsCurrentPageNumberSelector(store),
          customerCouponsError: CustomerCouponsErrorSelector(store),
          isFetchingRedemptionCodeRedemptions: IsFetchingRedemptionCodeRedemptionsSelector(store),
          languageHeader: LanguageHeaderSelector(store),
          numberOfPages: RedemptionCodeRedemptionsTotalPageNumberSelector(store),
          recordCount: RedemptionCodeRedemptionsRecordCountSelector(store),
          redemptionDateEndFilter: RedemptionCodeRedemptionsRedemptionDateEndFilterSelector(store),
          redemptionDateStartFilter: RedemptionCodeRedemptionsRedemptionDateStartFilterSelector(store),
          routeParams: RouteParams(store),
          selectedPageSizePreference: RedemptionCodeRedemptionsSelectedPageSizeSelector(store),
          tableData: {
            columnDefs: _this.columnDefs,
            data: CurrentRedemptionCodeTableDataSelector(store)
          },
          userPageSizePreference: SessionSelectors.PageSizePreferenceSelector(store),
          userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store)
        };
      };
      this.controllerActions = {
        searchCouponDetailsCouponRedemptions: searchCouponDetailsCouponRedemptions,
        setRedemptionCodeRedemptionsCurrentPage: setRedemptionCodeRedemptionsCurrentPage,
        setRedemptionCodeRedemptionsDateEndFilter: setRedemptionCodeRedemptionsDateEndFilter,
        setRedemptionCodeRedemptionsDateStartFilter: setRedemptionCodeRedemptionsDateStartFilter,
        setRedemptionCodeRedemptionsPageSizePreference: setRedemptionCodeRedemptionsPageSizePreference
      };
      this.disconnectRedux = this.$ngRedux.connect(this.mapStateToTarget, this.controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.routeParams.customerId) {
        this.columnDefs.push({
          field: 'Redeemer',
          displayName: i18n.translate(LocaleKeys.COUPONS.REDEEMER),
          width: '*'
        });
      }
      this.columnDefs.push({
        field: 'OrderNumber',
        displayName: i18n.translate(LocaleKeys.ORDER_NUMBER),
        cellTemplate: require('./cellTemplates/order.html'),
        width: 150
      }, {
        field: 'ProductPricingPlan',
        displayName: i18n.translate(LocaleKeys.COUPONS.PRODUCT_PRICING_PLAN),
        width: '*'
      });
      this.shouldShowEmptyState = undefined;
      this.initDateRange();
    }
  }, {
    key: "initDateRange",
    value: function initDateRange() {
      var entireHistoryDateShortcut = DateRangeShortcutHelper.getNullableOption(i18n.translate(LocaleKeys.ALL_TIME));
      this.shortcuts = [[entireHistoryDateShortcut].concat(DateRangeShortcutHelper.getRelativeShortListShortcuts())];
      this.onDateRangeChanged(entireHistoryDateShortcut.start, entireHistoryDateShortcut.end, entireHistoryDateShortcut);
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(page) {
      var _this2 = this;
      this.actions.setRedemptionCodeRedemptionsCurrentPage(page);
      this.searchCouponDetailsCouponRedemptions().then(function (response) {
        _this2.shouldShowEmptyState = _this2.shouldShowEmptyState === undefined ? Boolean(!response.RecordCount) : false;
      });
    }
  }, {
    key: "onDateRangeChanged",
    value: function onDateRangeChanged(start, end, shortcut) {
      this.selectedShortcut = shortcut;
      this.actions.setRedemptionCodeRedemptionsDateStartFilter(start);
      this.actions.setRedemptionCodeRedemptionsDateEndFilter(end);
      this.onPageSelected(1);
    }
  }, {
    key: "onPageSizeOptionSelected",
    value: function onPageSizeOptionSelected(pageSize) {
      this.actions.setRedemptionCodeRedemptionsPageSizePreference(pageSize);
      this.onPageSelected(1);
    }
  }, {
    key: "searchCouponDetailsCouponRedemptions",
    value: function searchCouponDetailsCouponRedemptions() {
      if (!this.state.selectedPageSizePreference) {
        this.actions.setRedemptionCodeRedemptionsPageSizePreference(this.state.userPageSizePreference);
      }
      var searchFilterData = {
        endDate: this.state.redemptionDateEndFilter,
        startDate: this.state.redemptionDateStartFilter,
        pageNumber: this.state.currentPageNumber,
        pageSize: this.state.selectedPageSizePreference,
        couponRedemptionCodeId: this.state.routeParams.couponRedemptionCodeId
      };
      return this.actions.searchCouponDetailsCouponRedemptions(this.state.routeParams.customerId, searchFilterData, this.state.languageHeader);
    }
  }, {
    key: "openResendRedemptionCodePopup",
    value: function openResendRedemptionCodePopup() {
      this.showResendRedemptionCodePopup = true;
      this.$timeout(this.resendRedemptionCodePopupApi.open);
    }
  }, {
    key: "closeResendRedemptionCodePopup",
    value: function closeResendRedemptionCodePopup(redemptionCodeResent, error) {
      this.showResendRedemptionCodePopup = false;
      this.resendRedemptionCodePopupApi.close();
      if (error) {
        this.resendRedemptionCodeErrorPopupApi.open();
      }
    }
  }, {
    key: "closeResendRedemptionCodeModalErrorPopup",
    value: function closeResendRedemptionCodeModalErrorPopup() {
      this.resendRedemptionCodeErrorPopupApi.close();
    }
  }, {
    key: "canResend",
    value: function canResend() {
      return this.userHasViewPermissions && this.redemptionCodeDetails.RedemptionCode.IsRedeemable && this.redemptionCodeDetails.RedemptionCode.SubscriberId;
    }
  }, {
    key: "userHasViewPermissions",
    get: function get() {
      return PermissionService.hasAccess(this.state.userSecurityAttributes, COUPON_REDEMPTION_CODE_VIEW_ACCESS);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
      this.resendRedemptionCodePopupApi.close();
      this.resendRedemptionCodeErrorPopupApi.close();
    }
  }]);
}();
export default {
  bindings: {
    redemptionCodeId: '<',
    redemptionCodeDetails: '<'
  },
  template: require('./redemption.code.details.redemptions.html'),
  controller: RedemptionCodeDetailsRedemptionsController
};